var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9899 11.8728C14.1954 11.8728 16.7934 9.2743 16.7934 6.06919C16.7934 2.86408 14.1954 0.265625 10.9899 0.265625C7.7843 0.265625 5.18629 2.86408 5.18629 6.06919C5.18629 9.2743 7.7843 11.8728 10.9899 11.8728ZM10.9899 1.71652C13.3902 1.71652 15.3425 3.66887 15.3425 6.06919C15.3425 8.46906 13.3902 10.4219 10.9899 10.4219C8.58954 10.4219 6.63719 8.4677 6.63719 6.06919C6.63719 3.66887 8.59135 1.71652 10.9899 1.71652ZM13.2886 14.0491H8.6911C4.35248 14.0491 0.833618 17.5675 0.833618 21.9066C0.833618 22.7744 1.5373 23.4785 2.40512 23.4785H19.5755C20.4433 23.4799 21.1461 22.7771 21.1461 21.9066C21.1461 17.5675 17.6277 14.0491 13.2886 14.0491ZM19.5728 22.029H2.40512C2.33892 22.029 2.28451 21.9746 2.28451 21.9066C2.28451 18.3746 5.15909 15.5 8.6911 15.5H13.2841C16.8206 15.5 19.6952 18.3746 19.6952 21.9066C19.6952 21.9746 19.6408 22.029 19.5728 22.029Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.b4e5b0da7bd467aae8af075c9886420d.svg";
export { ForwardRef as ReactComponent };